// src/pages/Trade.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import BecomeADealer from './PageComponent/become-a-dealer';

function Trade() {
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Become a Dealer in your region | Callistus Blinds</title>
                <meta
                    name="description"
                    content="If you wish to become a Callistus Dealer, please fill out the first-hand information as requested."
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/trade`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Become A Dealer" />
                <meta
                    property="og:description"
                    content="If you wish to become a Callistus Dealer, please fill out the first-hand information as requested."
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/trade`} />
                <meta property="og:site_name" content="Callistus Blinds" />
            </Helmet>

            <div>
                <Navbar />
                <NotificationBar />
                <BecomeADealer />
                <Footer />
            </div>
        </>
    );
}

export default Trade;